function isTrue(field) {
  return (
    (field && field.value && field.value === true) || (field && field === true)
  );
}
export default isTrue;
